export enum ProductUnitCategory {
  Quantity = 'QUANTITY',
  ServiceAndTime = 'SERVICE_TIME',
  Weight = 'WEIGHT',
  VolumeAndArea = 'VOLUME_AREA',
  Length = 'LENGTH',
  Packaging = 'PACKAGING',
  Custom = 'CUSTOM',
}
